import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeartHandshake, Building, Users, GraduationCap, Globe, Lightbulb, ArrowRight, CheckCircle, Clock, Award } from 'lucide-react';
export function Support() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-2468" data-mp="znjir67cj9q9">
      <Header data-id="element-2469" data-mp="zmzy3hqba78j" />
      <main className="flex-grow" data-id="element-2470" data-mp="zpm59g9aikq8">
        {/* Hero Section */}
        <section className="relative w-full bg-navy-50" data-id="element-2471" data-mp="2z3gc9j515vq">
          <div className="absolute inset-0 overflow-hidden" data-id="element-2472" data-mp="7wc3ypn2224d">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
            backgroundBlendMode: 'overlay'
          }} data-id="element-2473" data-mp="7ypucl6siq5l" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-navy-600/20" data-id="element-2474" data-mp="21x3vlfmsx1ks" />
          </div>
          <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-2475" data-mp="1wyak1sr2rkn9">
            <div className="max-w-3xl" data-id="element-2476" data-mp="1ww6d11xvq5ir">
              <h1 className="text-3xl md:text-5xl font-bold text-navy-800 mb-4" data-id="element-2477" data-mp="1rxwk6xzmnh0b">
                Support Our Mission
              </h1>
              <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-2478" data-mp="1mzlcassw7gkq"></div>
              <p className="text-lg md:text-xl text-navy-700 mb-8" data-id="element-2479" data-mp="1izb55ctd6k4a">
                Join us in advancing truth in microbiome science and bringing
                evidence-based solutions to communities worldwide. Your support
                makes our work possible.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-2480" data-mp="149vf5z1nqipn">
                <a href="#donate" className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm" data-id="element-2481" data-mp="1478yn9wsgsva">
                  Make a Donation
                </a>
                <a href="#partnerships" className="px-6 py-3 bg-navy-800 text-white rounded-md hover:bg-navy-900 transition-colors duration-200 shadow-sm" data-id="element-2482" data-mp="kmii0soo8qg2">
                  Explore Partnerships
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Why Support Section */}
        <section className="py-16 bg-white" data-id="element-2483" data-mp="14bsxq6of3be6">
          <div className="container mx-auto px-4" data-id="element-2484" data-mp="14c2ovxl77olg">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2485" data-mp="18cwdyuadn9fx">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-2486" data-mp="18f8rmv93qxn6">
                Why Support CalMiR
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2487" data-mp="zkud4uwebr54"></div>
              <p className="text-navy-600" data-id="element-2488" data-mp="zizvbpgf8f59">
                Your support enables us to conduct rigorous research, validate
                effective interventions, and bring microbiome science benefits
                to communities globally.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-2489" data-mp="21em9qutz3lw8">
              <div className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2490" data-mp="1xelksg98zsax">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2491" data-mp="2b69wwjjhygrw">
                  <Lightbulb className="text-teal-600" size={24} data-id="element-2492" data-mp="266du2nmjcvdx" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2493" data-mp="1igjfo1mkiyrk">
                  Advancing Science
                </h3>
                <p className="text-navy-600" data-id="element-2494" data-mp="1egsuqejq3cuy">
                  We're filling critical knowledge gaps in microbiome science
                  with pharmaceutical-grade research rigor, separating facts
                  from hype.
                </p>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2495" data-mp="33twbsny6d7u2">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2496" data-mp="2yvukjfqli27i">
                  <CheckCircle className="text-teal-600" size={24} data-id="element-2497" data-mp="18f922x3fzw7r" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2498" data-mp="1dcio02rmhpqu">
                  Truth in Wellness
                </h3>
                <p className="text-navy-600" data-id="element-2499" data-mp="1iatx2ba3fw80">
                  Our Ukweli Certified™ program brings much-needed validation
                  to the supplement industry, helping consumers make
                  evidence-based choices.
                </p>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-2500" data-mp="1wbefh6c3jq0z">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2501" data-mp="213xt23asal5s">
                  <Globe className="text-teal-600" size={24} data-id="element-2502" data-mp="260oaov28lotb" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2503" data-mp="2a4m8n2ftstks">
                  Global Impact
                </h3>
                <p className="text-navy-600" data-id="element-2504" data-mp="2f378h0r61b8p">
                  Through our{' '}
                  <a href="/about/afya-program" className="text-teal-600 hover:text-teal-700" data-id="element-2505" data-mp="3gdg7dnnupn4">
                    Afya Program
                  </a>
                  , we're bringing microbiome health solutions to underserved
                  communities worldwide, creating lasting change.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Donation Section */}
        <section id="donate" className="py-16 bg-navy-50" data-id="element-2506" data-mp="i3otpl3ekjpv">
          <div className="container mx-auto px-4" data-id="element-2507" data-mp="i6bbsenx6hmc">
            <div className="max-w-3xl mx-auto" data-id="element-2508" data-mp="dcow0dmglxmb">
              <div className="text-center mb-12" data-id="element-2509" data-mp="dbdrucp3qnuo">
                <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-2510" data-mp="8f6wtey8uwri">
                  Make a Donation
                </h2>
                <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2511" data-mp="15vcc1emlmmgj"></div>
                <p className="text-navy-600" data-id="element-2512" data-mp="112t3iw2rqhil">
                  Your financial support directly enables our research,
                  education, and global outreach efforts. All donations are
                  tax-deductible.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-2513" data-mp="1b6zmrj0p6t7q">
                <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-2514" data-mp="1b6rbfvk83vyn">
                  <div className="border border-navy-200 rounded-lg p-4 text-center hover:border-teal-500 hover:shadow-sm transition-all duration-200 cursor-pointer" data-id="element-2515" data-mp="1f7jjilhczutc">
                    <h3 className="text-2xl font-bold text-navy-800 mb-1" data-id="element-2516" data-mp="167n1v3tdzw7s">
                      $50
                    </h3>
                    <p className="text-navy-600 text-sm" data-id="element-2517" data-mp="s8x6ptq4o6m2">One-time donation</p>
                  </div>
                  <div className="border border-navy-200 rounded-lg p-4 text-center hover:border-teal-500 hover:shadow-sm transition-all duration-200 cursor-pointer" data-id="element-2518" data-mp="w8yzfddvxpp7">
                    <h3 className="text-2xl font-bold text-navy-800 mb-1" data-id="element-2519" data-mp="2qnrth7z4e8f1">
                      $100
                    </h3>
                    <p className="text-navy-600 text-sm" data-id="element-2520" data-mp="ezmy7n9zuj3e">One-time donation</p>
                  </div>
                  <div className="border border-navy-200 rounded-lg p-4 text-center hover:border-teal-500 hover:shadow-sm transition-all duration-200 cursor-pointer" data-id="element-2521" data-mp="azm998p9qpi3">
                    <h3 className="text-2xl font-bold text-navy-800 mb-1" data-id="element-2522" data-mp="jzhnxni192mv">
                      $250
                    </h3>
                    <p className="text-navy-600 text-sm" data-id="element-2523" data-mp="ynm6mrh35e5n">One-time donation</p>
                  </div>
                </div>
                <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-2524" data-mp="toj4beshpm1d">
                  <div className="border border-navy-200 rounded-lg p-4 text-center hover:border-teal-500 hover:shadow-sm transition-all duration-200 cursor-pointer" data-id="element-2525" data-mp="17plo1kw0ik94">
                    <h3 className="text-2xl font-bold text-navy-800 mb-1" data-id="element-2526" data-mp="12o65q0l7yruf">
                      $500
                    </h3>
                    <p className="text-navy-600 text-sm" data-id="element-2527" data-mp="34hvlyjyfwbuk">One-time donation</p>
                  </div>
                  <div className="border border-navy-200 rounded-lg p-4 text-center hover:border-teal-500 hover:shadow-sm transition-all duration-200 cursor-pointer" data-id="element-2528" data-mp="2jm7mpokx5bje">
                    <h3 className="text-2xl font-bold text-navy-800 mb-1" data-id="element-2529" data-mp="2nkwun1n6u0vn">
                      $1,000
                    </h3>
                    <p className="text-navy-600 text-sm" data-id="element-2530" data-mp="2xdm4xt7058pe">One-time donation</p>
                  </div>
                  <div className="border border-navy-200 rounded-lg p-4 text-center hover:border-teal-500 hover:shadow-sm transition-all duration-200 cursor-pointer" data-id="element-2531" data-mp="20nbqk7pi2n2x">
                    <h3 className="text-navy-800 mb-1" data-id="element-2532" data-mp="24q8e8ctwd9dq">Custom Amount</h3>
                    <p className="text-navy-600 text-sm" data-id="element-2533" data-mp="29lx9i3yvw448">Enter your own</p>
                  </div>
                </div>
                <div className="mb-6" data-id="element-2534" data-mp="2ekiaw6pvgtu9">
                  <label className="block text-sm font-medium text-navy-700 mb-1" data-id="element-2535" data-mp="3l36s6oa6us4h">
                    Donation Frequency
                  </label>
                  <div className="flex space-x-4" data-id="element-2536" data-mp="3pzx6p76chfns">
                    <div className="flex items-center" data-id="element-2537" data-mp="1eeo7t6df46yh">
                      <input id="one-time" name="frequency" type="radio" className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-navy-300 rounded" defaultChecked data-id="element-2538" data-mp="1eghiqxv2ddca" />
                      <label htmlFor="one-time" className="ml-2 text-navy-600" data-id="element-2539" data-mp="vnx2cfwjx0pd">
                        One-time
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-2540" data-mp="qn94ba9wnjln">
                      <input id="monthly" name="frequency" type="radio" className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-navy-300 rounded" data-id="element-2541" data-mp="lp7iwip0b870" />
                      <label htmlFor="monthly" className="ml-2 text-navy-600" data-id="element-2542" data-mp="2g1e326zvozbg">
                        Monthly
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-2543" data-mp="2j2z74oza97j6">
                      <input id="yearly" name="frequency" type="radio" className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-navy-300 rounded" data-id="element-2544" data-mp="2e5yz48ivhupf" />
                      <label htmlFor="yearly" className="ml-2 text-navy-600" data-id="element-2545" data-mp="2o1slejme92ke">
                        Yearly
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mb-6" data-id="element-2546" data-mp="2a3vlbd8qee0z">
                  <label className="block text-sm font-medium text-navy-700 mb-1" data-id="element-2547" data-mp="2a4x98iauiv04">
                    Donation Designation (Optional)
                  </label>
                  <select className="w-full px-4 py-2 border border-navy-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent" data-id="element-2548" data-mp="1hnkvfcoi75uw">
                    <option value="" data-id="element-2549" data-mp="1cnotrk3a3qii">General Support (All Programs)</option>
                    <option value="research" data-id="element-2550" data-mp="3objur50bumin">Research Programs</option>
                    <option value="afya" data-id="element-2551" data-mp="3t2jt8ep3hcn9">Afya Global Health Program</option>
                    <option value="education" data-id="element-2552" data-mp="3t4mrfm0eic32">Education & Outreach</option>
                    <option value="certification" data-id="element-2553" data-mp="3eeyn0bwxaxb4">
                      Ukweli Certification Program
                    </option>
                  </select>
                </div>
                <button type="button" className="w-full px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm" data-id="element-2554" data-mp="awnla43aiv9z">
                  Proceed to Donation
                </button>
                <div className="mt-4 text-center text-sm text-navy-500" data-id="element-2555" data-mp="5xkfghfhkl0y">
                  CalMiR is a 501(c)(3) nonprofit organization. All donations
                  are tax-deductible to the extent allowed by law.
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Impact Section */}
        <section className="py-16 bg-white" data-id="element-2556" data-mp="x414ebsvfv5o">
          <div className="container mx-auto px-4" data-id="element-2557" data-mp="s69chhs8891h">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2558" data-mp="s7kdxay794pf">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-2559" data-mp="nf11ihb90fm7">
                Your Impact
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2560" data-mp="ih7u5ky7lfkc"></div>
              <p className="text-navy-600" data-id="element-2561" data-mp="eel1jhtprqm3">
                Here's how your support translates into real-world impact:
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-2562" data-mp="9e6thzs44go2">
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2563" data-mp="4hq4l3d39y9x">
                <div className="flex items-start" data-id="element-2564" data-mp="3vmzn69yr7a9i">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2565" data-mp="3vo9mf2hceohq">
                    <Award className="text-teal-600" size={20} data-id="element-2566" data-mp="1yv7tout57372" />
                  </div>
                  <div data-id="element-2567" data-mp="1tvuz1nw14rtx">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2568" data-mp="1two6kr2tbld4">
                      $50
                    </h3>
                    <p className="text-navy-600" data-id="element-2569" data-mp="22c3wjxf2uzya">
                      Provides laboratory supplies for testing one probiotic
                      sample for safety and efficacy
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2570" data-mp="2g4a44v45zym4">
                <div className="flex items-start" data-id="element-2571" data-mp="2g5uxiheqtbie">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2572" data-mp="1jesygg56mckf">
                    <Award className="text-teal-600" size={20} data-id="element-2573" data-mp="1nete2440ott2" />
                  </div>
                  <div data-id="element-2574" data-mp="1sepj86ogara7">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2575" data-mp="1se6a9fgs3d8b">
                      $100
                    </h3>
                    <p className="text-navy-600" data-id="element-2576" data-mp="1xf3tlvdiydbe">
                      Supports the development of educational materials for
                      healthcare providers in underserved communities
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2577" data-mp="ll9txuyni2cm">
                <div className="flex items-start" data-id="element-2578" data-mp="gl5feahazhp1">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2579" data-mp="gmq7ltg5aojq">
                    <Award className="text-teal-600" size={20} data-id="element-2580" data-mp="ul6ouebmvxg4" />
                  </div>
                  <div data-id="element-2581" data-mp="plbz4e3lhdwn">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2582" data-mp="pksdoneqk7dv">
                      $250
                    </h3>
                    <p className="text-navy-600" data-id="element-2583" data-mp="14h9rrmeb8044">
                      Funds a microbiome analysis for one participant in our
                      clinical research studies
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2584" data-mp="199kq4ktejduk">
                <div className="flex items-start" data-id="element-2585" data-mp="19c6ygmo49xdu">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2586" data-mp="1nadmzc76el0u">
                    <Award className="text-teal-600" size={20} data-id="element-2587" data-mp="1ib10isk7vfys" />
                  </div>
                  <div data-id="element-2588" data-mp="21wkexl9bexk0">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2589" data-mp="21w1932wxvzmc">
                      $1,000
                    </h3>
                    <p className="text-navy-600" data-id="element-2590" data-mp="26uvri3qzvm5x">
                      Enables the complete testing cycle for one supplement in
                      our Ukweli Certified™ program
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Partnership Section */}
        <section id="partnerships" className="py-16 bg-navy-50" data-id="element-2591" data-mp="1nx1k1u5ilipn">
          <div className="container mx-auto px-4" data-id="element-2592" data-mp="1nymfdlznl5ok">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2593" data-mp="198olcpf1llrg">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-2594" data-mp="1e6q6rgzxxx63">
                Partnership Opportunities
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2595" data-mp="106p5w1joepqm"></div>
              <p className="text-navy-600" data-id="element-2596" data-mp="148ao82ezbw87">
                We collaborate with organizations that share our commitment to
                scientific integrity and improving global health through
                microbiome science.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-2597" data-mp="32368xj4f8tzq">
              <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2598" data-mp="2x4mrnw0rw6dp">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2599" data-mp="2s7mhpa0syjhb">
                  <Building className="text-teal-600" size={24} data-id="element-2600" data-mp="3ptjvwv85g2ng" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2601" data-mp="3kwa9log2473u">
                  Corporate Partnerships
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-2602" data-mp="3fxyylae0zqk1">
                  Collaborate with us on research initiatives, product
                  validation, or CSR programs aligned with our mission.
                </p>
                <a href="/contact" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-2603" data-mp="20f5aokwcaxwp">
                  Explore corporate opportunities
                  <ArrowRight size={16} className="ml-1" data-id="element-2604" data-mp="jzq0ixao8k97" />
                </a>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2605" data-mp="owq7rbj9bt1w">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2606" data-mp="tp9lc8hy2o6p">
                  <Users className="text-teal-600" size={24} data-id="element-2607" data-mp="ynb40sbgklhn" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2608" data-mp="13lcl57pbqaqh">
                  Research Collaborations
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-2609" data-mp="17m6dqedpodpp">
                  Partner with our scientists on joint research projects,
                  clinical trials, or technology development initiatives.
                </p>
                <a href="/research-hub/partnerships" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-2610" data-mp="3eeqi8f7o4ehc">
                  Learn about research partnerships
                  <ArrowRight size={16} className="ml-1" data-id="element-2611" data-mp="1g5189tm0xiy1" />
                </a>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2612" data-mp="1tvwk9ertkg5u">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-2613" data-mp="1ozo9edknn94h">
                  <GraduationCap className="text-teal-600" size={24} data-id="element-2614" data-mp="119tvrtsihgj6" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2615" data-mp="x8rwxe2ib6hq">
                  Educational Partnerships
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-2616" data-mp="166kd0kg1yi66">
                  Collaborate on educational programs, curriculum development,
                  or training initiatives for healthcare providers.
                </p>
                <a href="/contact" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-2617" data-mp="2hl7eseiktebj">
                  Discuss educational initiatives
                  <ArrowRight size={16} className="ml-1" data-id="element-2618" data-mp="8bhtsd3ik4yp" />
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Other Ways to Support */}
        <section className="py-16 bg-white" data-id="element-2619" data-mp="3vik5rhofhw0t">
          <div className="container mx-auto px-4" data-id="element-2620" data-mp="n1yqxk9488ps">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2621" data-mp="n3a5mf43n0vo">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-2622" data-mp="r30s46mleuue">
                Other Ways to Support
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-2623" data-mp="dc5p3ayrz7yq"></div>
              <p className="text-navy-600" data-id="element-2624" data-mp="iaqh4n3vilc3">
                Beyond financial contributions, there are many ways to support
                our mission.
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-2625" data-mp="1askw93rqjew3">
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2626" data-mp="1r1k4omg5um52">
                <div className="flex items-start" data-id="element-2627" data-mp="1r23ns6hjrgko">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2628" data-mp="1w0dkwmmu0r8x">
                    <Clock className="text-teal-600" size={20} data-id="element-2629" data-mp="1w2rh4yt909i2" />
                  </div>
                  <div data-id="element-2630" data-mp="1i906fn3s6jkr">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2631" data-mp="1mau03bfk6nbf">
                      Volunteer
                    </h3>
                    <p className="text-navy-600 mb-3" data-id="element-2632" data-mp="18asytuvdtdvf">
                      Contribute your time and skills to support our
                      administrative, research, or outreach activities.
                    </p>
                    <a href="/contact" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200 text-sm" data-id="element-2633" data-mp="zbpeknkhasfc">
                      Learn about volunteer opportunities
                      <ArrowRight size={14} className="ml-1" data-id="element-2634" data-mp="2xqaakc0lqj1k" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2635" data-mp="m0kmp78q1kup">
                <div className="flex items-start" data-id="element-2636" data-mp="i23e0j9nk2b6">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2637" data-mp="hz8tysujwjia">
                    <Users className="text-teal-600" size={20} data-id="element-2638" data-mp="vu1ek5paspvq" />
                  </div>
                  <div data-id="element-2639" data-mp="r0ylrzschkgl">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2640" data-mp="qznf9s7ilyls">
                      Participate in Research
                    </h3>
                    <p className="text-navy-600 mb-3" data-id="element-2641" data-mp="10s3150lxn7by">
                      Join our clinical studies as a participant to help advance
                      microbiome science.
                    </p>
                    <a href="/research-hub/participate" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200 text-sm" data-id="element-2642" data-mp="19rzs58vsoia6">
                      View current studies
                      <ArrowRight size={14} className="ml-1" data-id="element-2643" data-mp="1fgg9xlspm6vs" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2644" data-mp="1kgcepn98e2ce">
                <div className="flex items-start" data-id="element-2645" data-mp="1pew27s3h3m6v">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2646" data-mp="1pdchnpasaoza">
                    <HeartHandshake className="text-teal-600" size={20} data-id="element-2647" data-mp="1thags003zzsc" />
                  </div>
                  <div data-id="element-2648" data-mp="1yeaosggircm3">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2649" data-mp="1yesrnvxosp2z">
                      Planned Giving
                    </h3>
                    <p className="text-navy-600 mb-3" data-id="element-2650" data-mp="28559vhi1465y">
                      Include CalMiR in your estate planning to create a lasting
                      legacy in microbiome science.
                    </p>
                    <a href="/support/planned-giving" className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200 text-sm" data-id="element-2651" data-mp="2h63i6bzi2zuc">
                      Learn about planned giving
                      <ArrowRight size={14} className="ml-1" data-id="element-2652" data-mp="af6y27x3ueag" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg" data-id="element-2653" data-mp="1hwmsmkaep5j">
                <div className="flex items-start" data-id="element-2654" data-mp="3sn65dt5yc154">
                  <div className="bg-teal-100 p-2 rounded-full mr-4" data-id="element-2655" data-mp="3soqxlc4sn7zt">
                    <Globe className="text-teal-600" size={20} data-id="element-2656" data-mp="t8arbs6eup4j" />
                  </div>
                  <div data-id="element-2657" data-mp="p5xnj9b851ae">
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-2658" data-mp="p7ikt6oxayby">
                      Spread the Word
                    </h3>
                    <p className="text-navy-600 mb-3" data-id="element-2659" data-mp="kdmmg34qz9g9">
                      Share our mission with your network and help us reach more
                      people with evidence-based microbiome science.
                    </p>
                    <div className="flex space-x-3" data-id="element-2660" data-mp="185lc5s4y17cx">
                      <a href="https://twitter.com/intent/tweet?text=Check%20out%20CalMiR%27s%20work%20in%20microbiome%20science!&url=https://calmir.org" target="_blank" rel="noopener noreferrer" className="text-navy-600 hover:text-teal-600" data-id="element-2661" data-mp="1840hm2impof2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2662" data-mp="nnfka5u26cpr">
                          <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" data-id="element-2663" data-mp="16kqkbsnila69"></path>
                        </svg>
                      </a>
                      <a href="https://www.facebook.com/sharer/sharer.php?u=https://calmir.org" target="_blank" rel="noopener noreferrer" className="text-navy-600 hover:text-teal-600" data-id="element-2664" data-mp="28hedbchajljp">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2665" data-mp="2d8mooe26lgzi">
                          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-2666" data-mp="3awocmxu3ytdu"></path>
                        </svg>
                      </a>
                      <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://calmir.org" target="_blank" rel="noopener noreferrer" className="text-navy-600 hover:text-teal-600" data-id="element-2667" data-mp="35x1x2hqt511v">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2668" data-mp="3mwv1hym14edu">
                          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-2669" data-mp="39082zrefhg5t"></path>
                          <rect x="2" y="9" width="4" height="12" data-id="element-2670" data-mp="2bj9ccdg66csb"></rect>
                          <circle cx="4" cy="4" r="2" data-id="element-2671" data-mp="2ghu2tl5mdi3k"></circle>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="py-16 bg-teal-600 text-white" data-id="element-2672" data-mp="1z0nha2sj3d29">
          <div className="container mx-auto px-4" data-id="element-2673" data-mp="1z39nnz3onmiw">
            <div className="max-w-3xl mx-auto text-center" data-id="element-2674" data-mp="1u2viqpxdosp3">
              <h2 className="text-3xl font-bold mb-4" data-id="element-2675" data-mp="1q0ianuv5sip5">
                Join Our Mission Today
              </h2>
              <p className="text-teal-100 mb-8" data-id="element-2676" data-mp="1la1w27flqr17">
                Together, we can advance truth in microbiome science and create
                a healthier future for communities worldwide.
              </p>
              <div className="flex flex-wrap justify-center gap-4" data-id="element-2677" data-mp="1bc48zn9hb0a6">
                <a href="#donate" className="px-6 py-3 bg-white text-teal-600 rounded-md hover:bg-navy-50 transition-colors duration-200 shadow-sm" data-id="element-2678" data-mp="1b9rker97tro5">
                  Make a Donation
                </a>
                <a href="/contact" className="px-6 py-3 bg-teal-700 text-white border border-teal-400 rounded-md hover:bg-teal-800 transition-colors duration-200" data-id="element-2679" data-mp="2q8x6blpb4szo">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-2680" data-mp="2lac27b6xpp5y" />
    </div>;
}